import { createApp } from 'vue'
import App from './App.vue'
import axiosPlugin from './plugins/axios'
import router from './router'         // Importa o arquivo de rotas
import store from './store'           // Importa o Vuex store
import vuetify, { i18n } from './plugins/vuetify' // Importa o Vuetify e o i18n
import './css/estilos.css'; // Importação global do CSS


const app = createApp(App)

// Registra os plugins e dependências
app.use(router)      // Configura o Vue Router
app.use(store)       // Configura o Vuex
app.use(vuetify)     // Configura o Vuetify
app.use(i18n)        // Configura o vue-i18n
app.use(axiosPlugin) // Configura o Axios

// Monta o aplicativo na DOM
app.mount('#app')
